import { assign, uniq } from "lodash"
import { BUILDING_AGGREGATES } from "../buildingSummaryNewDesign/constants"
import { processOfferings } from "src/utils/OfferingUtils/offeringUtils"


export const removeSpaceInString = (string: string) =>
  string?.trim()?.replace(/\s\s+/g, " ")


export const formatsearchBuildingsData = (searchBuildingsData) => {
  return searchBuildingsData?.items?.map((building: any) => {
    const processedOfferings = processOfferings(building?.offerings?.items, building?.tz) || {}
    assign(building, processedOfferings)
    building.deviceConnectivity = building?.deviceConnectivity?.split(",")
    return building
  })
}


export const groupToFilter = (groups) => {
  return groups.reduce((acc, item) => {
    if (!acc[item.outerCondition]) {
      acc[item.outerCondition] = []
    }
    acc[item.outerCondition] = [...acc[item.outerCondition], {
      [item.groupCondition]: item.query.map(q => {
        const type = BUILDING_AGGREGATES.find(fil => fil.name === q.type).field;
        if (q.operation === "contains") {
          return ({
            [type]: { wildcard: `*${q.value}*` }
          })
        } else if ((q.operation === "notContains")) {
          return ({
            not: {
              [type]: { wildcard: `${q.value}*` }
            }
          })
        }
        else if (type === "deviceConnectivity" || type === "offeringCodes") {
          return ({
            [type]: { matchPhrasePrefix: `*${q.value}*` }
          })
        }
        return ({
          [type]: {
            [q.operation]: q.value
          }
        })
      })
    }]
    return acc
  }, {})
}
export const UiFilterToGroup = (filter) => {
  const field = Object.keys(filter);
  const groups = field.reduce((acc, curr) => {
    const temp = filter[curr];

    const group = {
      groupCondition: "or",
      outerCondition: "and",
      query: temp.map(item => {

        const field = Object.keys(item)[0]
        const type = BUILDING_AGGREGATES.find(fil => fil.field === field).name
        const operation = Object.keys(item[field])[0]
        const value = item[field][operation]
        return ({
          type,
          operation,
          value
        })
      })
    }
    acc.push(group)
    return acc
  }, [])
  return {
    groups
  }
}

